import Checkbox from '../checkbox'
import Icon from '../icon'

var prefixCls = 'ivu-tree-table',
    uid = 0

// tree-table单元格
export default {
    name: 'TreeTableCell',
    functional: true,
    inject: ['treeRoot', 'treeNode'],
    props: {
        column: {
            type: Object,
        },
        data: {
            type: Object,
        },
        node: {
            type: Object,
        },
        validation: {
            type: Object,
            default: () => ({}),
        },
    },
    render(h, ctx) {
        var { props, injections, listeners } = ctx
        var { column, data, node, validation } = props
        var { treeRoot, treeNode } = injections
        var errors = validation.errors || [],
            canEdit = column.canEdit,
            cellEditing,
            cellEditable,
            children = []

        // 自定义单元格默认可编辑
        if (
            canEdit === undefined &&
            (column.render || column.slot || column.edit)
        ) {
            canEdit = true
        }
        // 自定义
        else if (typeof canEdit === 'function') {
            canEdit = canEdit({
                row: data,
                column: column,
                index: node.nodeKey,
                value: data[column.key],
                node: node,
            })
        }
        // 普通cell不可编辑
        else {
            canEdit = false
        }
        // 当前cell是否处于编辑状态
        cellEditing = canEdit && node._isEditing
        // 当前cell是否能够编辑
        cellEditable = canEdit && node._isHover

        // 缩进cell
        if (column.indent) {
            var indentChildren = []
            // arrow
            if (node._isLoading !== undefined || node.children.length > 0) {
                indentChildren.push(
                    h(Icon, {
                        ref: 'arrow',
                        props: {
                            type: 'ios-arrow-forward',
                        },
                    })
                )
            }
            // loading
            if (node._isLoading) {
                indentChildren.push(
                    h(Icon, {
                        ref: 'arrow',
                        class: ['ivu-load-loop'],
                        props: {
                            type: 'ios-loading',
                        },
                    })
                )
            }
            children.push(
                h(
                    'span',
                    {
                        class: [
                            `${prefixCls}-arrow`,
                            {
                                [`${prefixCls}-arrow-disabled`]: node._isDisabled,
                                [`${prefixCls}-arrow-open`]: node._isExpand,
                            },
                        ],
                        style: {
                            marginLeft: node.level * treeRoot.indentSize + 'px',
                        },
                    },
                    indentChildren
                )
            )
            // checkbox
            if (treeRoot.showCheckbox) {
                children.push(
                    h(Checkbox, {
                        props: {
                            value: node._isChecked,
                            indeterminate: node._isIndeterminate,
                            disabled:
                                node._isDisabled || node._isDisableCheckbox,
                        },
                        nativeOn: {
                            click(e) {
                                e.preventDefault()
                                treeNode.handleCheck()
                            },
                        },
                    })
                )
            }
        }
        // 序号cell
        if (column.type === 'index') {
            children.push(h('span', node.nodeKey + 1))
        } else if (column.slot) {
            children.push(
                treeRoot.$scopedSlots[column.slot]({
                    column,
                    row: data,
                    node,
                    index: node.nodeKey,
                    editing: node._isEditing,
                    cellEditing,
                    cellEditable,
                })
            )
        } else if (column.render) {
            children.push(
                column.render(h, {
                    column,
                    row: data,
                    index: node.nodeKey,
                    node,
                    editing: node._isEditing,
                    cellEditing,
                    cellEditable,
                })
            )
        } else {
            // normal cell
            children.push(
                h(
                    'span',
                    {
                        attrs: {
                            'data-cls': 'cell-content',
                        },
                    },
                    data[column.key]
                )
            )
        }

        // render
        return h(
            'div',
            {
                ref: column.indent ? 'indentCell' : '',
                // cellClass
                class: [
                    prefixCls + '-cell',
                    column.className || '',
                    (data.cellClassName && data.cellClassName[column.key]) ||
                        '',
                    {
                        [`${prefixCls}-cell-with-error`]: errors.length > 0,
                        [`${prefixCls}-cell-in-readonly`]: !cellEditing,
                        [`${prefixCls}-cell-ellipsis`]:
                            column.ellipsis || column.tooltip || false,
                    },
                ],
                // cellStyle
                style: {
                    width: column.width + 'px',
                    'text-align': column.align,
                },
                attrs: {
                    'data-uid': uid++,
                },
                on: {
                    mouseenter(e) {
                        var $cell = e.target

                        treeNode.handleShowPopper($cell, column)
                    },
                    mouseleave(e) {
                        treeRoot.handleClosePopper()
                    },
                    ...listeners,
                },
            },
            children
        )
    },
}
